import { render, staticRenderFns } from "./upgradePlan.vue?vue&type=template&id=5c39d8b4&scoped=true"
import script from "./upgradePlan.vue?vue&type=script&lang=js"
export * from "./upgradePlan.vue?vue&type=script&lang=js"
import style0 from "./upgradePlan.vue?vue&type=style&index=0&id=5c39d8b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c39d8b4",
  null
  
)

export default component.exports